// extracted by mini-css-extract-plugin
export default {"shadowed":"About_shadowed__JxXDK","pink":"About_pink__6rOiZ","green":"About_green__aX+xj","skills":"About_skills__oAN8o"};